/**
 * @file passMkd.js
 * @description 滑动验证码
 */

// 滑动验证码实例
let passMkdInstance = null;

export default {

    /**
     * 初始化并展示滑动验证码组件
     *
     * @return {Promise<Object>} ds和tk值，验证是否为人机
     */
    showMkd({state}) {
        if (window.PassMachine && window.PassMachine.mkd) {
            const PassMkd = window.PassMachine.mkd;
            return new Promise((resolve, reject) => {
                passMkdInstance = new PassMkd({
                    // 产品线接入ak
                    ak: state.mkdAppkey,
                    // 初始化完毕，渲染验证码到容器中
                    initApiSuccessFn: function () {
                        passMkdInstance.initVcode();
                    },
                    // 是否选择弹层模式
                    maskModule: true,
                    // 关闭弹窗
                    closeFn: () => {
                        reject();
                    },
                    // 验证结果的回调函数
                    verifySuccessFn: data => {
                        // 可以拿到ds 和 tk 去问反作弊是否是人机。
                        resolve(data);
                        // 清除弹层
                        passMkdInstance.removeMask();
                    }
                });
            });
        }
    },

    /**
     * 移除滑动验证码弹层
     */
    removeMkdMask() {
        passMkdInstance && passMkdInstance.removeMask();
    }
};
